import { action } from 'typesafe-actions';
import { IApiQueryOptions } from 'api/ApiClient';
import { IAcceptancePayment, IApiList, ITipAcceptancePaymentSetPayouts, ITipAcceptancePaymentSetRequestPayload } from 'types';
import { TipAcceptance } from './types';

export const getPaymentsRequest = (siteId: string, options?: IApiQueryOptions) => action(TipAcceptance.GET_PAYMENTS_REQUEST, { siteId, options });
export const getPaymentsSuccess = (response: IApiList<IAcceptancePayment>) => action(TipAcceptance.GET_PAYMENTS_SUCCESS, response);
export const getPaymentsError = (error: any) => action(TipAcceptance.GET_PAYMENTS_FAIL, error);

export const getPaymentSetRequest = (options: ITipAcceptancePaymentSetRequestPayload, onSuccess: (paymentSet: ITipAcceptancePaymentSetPayouts) => void) => action(TipAcceptance.GET_PAYMENT_SET_REQUEST, { options, onSuccess });
export const getPaymentSetSuccess = (response: ITipAcceptancePaymentSetPayouts) => action(TipAcceptance.GET_PAYMENT_SET_SUCCESS, response);
export const getPaymentSetFail = (error: any) => action(TipAcceptance.GET_PAYMENT_SET_FAIL, error);
